import { makeStyles, Theme } from '@material-ui/core';

import { CUSTOM_BLUE } from 'utils/colours';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  filterChip: {
    margin: theme.spacing(0, 0.25, 0, 0.25),
    padding: theme.spacing(0, 1, 0, 1),
    height: '24px',
    '& .MuiChip-label': {
      color: CUSTOM_BLUE,
      fontWeight: 600,
      fontSize: '1rem',
      font: 'inter',
    },
  },
  filterBox: {
    paddingBottom: theme.spacing(2.5),
    width: '100%',
    height: 'fit-content',
    minHeight: '32px',
  },
  renderInput: {
    minHeight: '32px',
    height: 'fit-content',
  },
}));

export default useStyles;
